import {createAction} from '@reduxjs/toolkit';

const CLEAN_EVENTS_INFO = 'CLEAN_EVENTS_INFO';

export const cleanEventsInfo = createAction(CLEAN_EVENTS_INFO);
